function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconMailMediumOutline = function IconMailMediumOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V8c0-.127.015-.251.038-.372.023.03.033.065.061.092l5.78 5.78a2.99 2.99 0 002.121.862 2.99 2.99 0 002.121-.862l5.78-5.78c.028-.028.038-.063.061-.092.023.121.038.245.038.372v8zM18 6c.259 0 .505.053.732.143-.086.045-.172.09-.245.163l-5.78 5.78c-.363.363-1.051.363-1.414 0l-5.78-5.78c-.073-.072-.159-.117-.245-.162A1.96 1.96 0 016 6h12zM6 4C3.8 4 2 5.8 2 8v8c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4H6z",
    clipRule: "evenodd"
  }));
};

export default IconMailMediumOutline;